import { useEffect, useState } from "react";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { debounce } from "@mui/material";

export default function CreateOrder({ show, closeModal, refreshPage, setParentSuccess }) {
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [company, setCompany] = useState([]);
  const [products, setProducts] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [orderForms, setOrderForms] = useState([createInitialForm()]);
  const [warehouses, setWarehouses] = useState([]);
  const [availableQuantities, setAvailableQuantities] = useState([]);
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  function createInitialForm() {
    return {
      customer_id: "",
      company_detail_id: "",
      category_id: "",
      sub_category_id: "",
      product_id: "",
      quantity: 1,
      price: "0",
      payment_type: "",
      discount: "0",
      total_price: "0.00",
      status: "",
      remaining_stock: 0,
      warehouse_id: "",
      available_quantity: 0,
      warehouseName: "",
      customer_label: ""
    };
  }

  const storedPermissions = localStorage.getItem("userPermissions");
  const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  const userDataString = localStorage.getItem("userData");
  let userTypeId = null;

  if (userDataString) {
    const userData = JSON.parse(userDataString);
    userTypeId = userData.user.user_type_id;
  }

  const hasPermission = (permission) => {
    return Array.isArray(permissions) && permissions.includes(permission);
  };

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // const customerResponse = await axiosInstance.get("/user/customer/fetch_customer_no_paginate");
        // setCustomers(customerResponse.data.data.customer);

        const categoryResponse = await axiosInstance.get("/user/category/fetch");
        setCategories(categoryResponse.data.data.category.data);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchData();
  }, []);

  // const loadCustomerOptions = (inputValue, callback) => {
  //   setIsCustomerLoading(true);
  //   axiosInstance
  //     .get(`/user/customer/fetch_customer_no_paginate?search=${inputValue}`)
  //     .then((response) => {
  //       const options = response.data.data.customer.map((customer) => ({
  //         label: `${customer.first_name}`,
  //         value: customer.customer_id,
  //       }));
  //       callback(options);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching customers", error);
  //       callback([]);
  //     });
  // };

  const loadCustomerOptions = debounce((inputValue, callback) => {
    setIsCustomerLoading(true);
    axiosInstance
      .get(`/user/customer/fetch_customer_no_paginate?search=${inputValue}`)
      .then((response) => {
        const options = response.data.data.customer.map((customer) => ({
          // label: `${customer.first_name} ${customer.last_name || ''}`,
          label: `${customer.first_name}`,
          value: customer.customer_id,
        }));
        setIsCustomerLoading(false);
        callback(options);
      })
      .catch((error) => {
        console.error("Error fetching customers", error);
        setIsCustomerLoading(false);
        callback([]);
      });
  }, 300);

  // Fetch subcategories
  const fetchSubCategories = async (categoryId, index) => {
    if (categoryId) {
      try {
        const response = await axiosInstance.get(`/user/category/getSubCategory?category_id=${categoryId}`);
        setSubCategories((prev) => {
          const newSubCategories = [...prev];
          newSubCategories[index] = response.data.data.subCategories;
          return newSubCategories;
        });
      } catch (error) {
        console.error("Error fetching subcategories", error);
      }
    }
  };

  // Fetch customer company
  const fetchCustomerCompany = async (customerId, index) => {
    if (customerId) {
      try {
        const response = await axiosInstance.get(`/user/customer/fetch_customer_company/${customerId}`);
        setCompany((prev) => {
          const newCompanies = [...prev];
          newCompanies[index] = response.data.data.company;
          return newCompanies;
        });
      } catch (error) {
        console.error("Error fetching customer company", error);
      }
    }
  };

  // Fetch products
  const fetchProducts = async (subcategoryId, index) => {
    if (subcategoryId) {
      try {
        const response = await axiosInstance.get(`/user/order/get_product_by_subcategory?sub_category_id=${subcategoryId}`);
        setProducts((prev) => {
          const newProducts = [...prev];
          newProducts[index] = response.data.data.products;
          return newProducts;
        });
      } catch (error) {
        console.error("Error fetching products", error);
      }
    }
  };

  // Fetch warehouse and quantity
  const fetchWarehouseAndQuantity = async (productId, index) => {
    if (productId) {
      try {
        const response = await axiosInstance.get(`/user/check_in/get-checkIn/${productId}`);
        const warehouseData = response.data.data.item;
        const warehouseName = warehouseData.name;
        const warehouseId = Number(warehouseData.ware_house_id);
        const availableQuantity = warehouseData.quantity;

        setWarehouses((prev) => {
          const newWarehouses = [...prev];
          newWarehouses[index] = warehouseName;
          return newWarehouses;
        });

        const updatedForms = [...orderForms];
        updatedForms[index].warehouse_id = warehouseId;
        updatedForms[index].available_quantity = availableQuantity;
        updatedForms[index].warehouseName = warehouseName;
        setOrderForms(updatedForms);
      } catch (error) {
        console.error("Error fetching warehouse and quantity", error);
      }
    }
  };

  // Handle customer change
  // const handleCustomerChange = (index, selectedOption) => {
  //   const updatedForms = [...orderForms];
  //   const newCustomerId = selectedOption ? selectedOption.value : "";

  //   updatedForms[index].customer_id = newCustomerId;
  //   updatedForms[index].company_detail_id = "";

  //   setOrderForms(updatedForms);

  //   setCompany((prev) => {
  //     const newCompanies = [...prev];
  //     newCompanies[index] = [];
  //     return newCompanies;
  //   });

  //   if (newCustomerId) {
  //     fetchCustomerCompany(newCustomerId, index);
  //   }
  // };

  const handleCustomerChange = (index, selectedOption) => {
    const updatedForms = [...orderForms];
    const newCustomerId = selectedOption ? selectedOption.value : "";
    const newCustomerLabel = selectedOption ? selectedOption.label : "";

    updatedForms[index].customer_id = newCustomerId;
    updatedForms[index].customer_label = newCustomerLabel;
    updatedForms[index].company_detail_id = "";

    setOrderForms(updatedForms);

    setCompany((prev) => {
      const newCompanies = [...prev];
      newCompanies[index] = [];
      return newCompanies;
    });

    if (newCustomerId) {
      fetchCustomerCompany(newCustomerId, index);
    }
  };

  const handleCompanyChange = (index, selectedOption) => {
    const updatedForms = [...orderForms];
    updatedForms[index].company_detail_id = selectedOption ? selectedOption.value : "";
    setOrderForms(updatedForms);
  };

  // Handle category change
  const handleCategoryChange = (index, selectedOption) => {
    const updatedForms = [...orderForms];
    const newCategoryId = selectedOption ? selectedOption.value : "";

    // Reset dependent fields
    updatedForms[index].category_id = newCategoryId;
    updatedForms[index].sub_category_id = "";
    updatedForms[index].product_id = "";
    updatedForms[index].price = "0";
    updatedForms[index].total_price = "0.00";
    updatedForms[index].warehouse_id = "";
    updatedForms[index].available_quantity = 0;
    updatedForms[index].warehouseName = "";

    setOrderForms(updatedForms);

    // Clear subcategories and products for this index
    setSubCategories((prev) => {
      const newSubCategories = [...prev];
      newSubCategories[index] = [];
      return newSubCategories;
    });
    setProducts((prev) => {
      const newProducts = [...prev];
      newProducts[index] = [];
      return newProducts;
    });

    // Fetch new subcategories if a category is selected
    if (newCategoryId) {
      fetchSubCategories(newCategoryId, index);
    }
  };

  // Handle subcategory change
  const handleSubCategoryChange = (index, selectedOption) => {
    const updatedForms = [...orderForms];
    const newSubCategoryId = selectedOption ? selectedOption.value : "";

    // Reset dependent fields
    updatedForms[index].sub_category_id = newSubCategoryId;
    updatedForms[index].product_id = "";
    updatedForms[index].price = "0";
    updatedForms[index].total_price = "0.00";
    updatedForms[index].warehouse_id = "";
    updatedForms[index].available_quantity = 0;
    updatedForms[index].warehouseName = "";

    setOrderForms(updatedForms);

    // Clear products for this index
    setProducts((prev) => {
      const newProducts = [...prev];
      newProducts[index] = [];
      return newProducts;
    });

    // Fetch new products if a subcategory is selected
    if (newSubCategoryId) {
      fetchProducts(newSubCategoryId, index);
    }
  };

  // Handle product change
  const handleProductChange = (index, selectedOption) => {
    const productId = selectedOption ? selectedOption.value : "";
    const selectedProduct = products[index]?.find((p) => p.id === parseInt(productId));
    const updatedForms = [...orderForms];

    updatedForms[index].product_id = productId;
    updatedForms[index].price = selectedProduct ? selectedProduct.price : "0";
    updatedForms[index].discount = "";
    updatedForms[index].total_price = calculateTotalPriceWithDiscount(
      parseFloat(selectedProduct?.price) || 0,
      updatedForms[index].discount
    ).toFixed(2);

    setOrderForms(updatedForms);

    // Fetch warehouse and quantity if a product is selected
    if (productId) {
      fetchWarehouseAndQuantity(productId, index);
    }
  };

  const handleQuantityChange = (index, e) => {
    let { value } = e.target;
    value = parseInt(value, 10);
    const updatedForms = [...orderForms];
    updatedForms[index].quantity = Math.max(1, value);

    if (updatedForms[index].quantity > updatedForms[index].available_quantity) {
      toast.warn("Selected quantity exceeds available quantity in warehouse");
      updatedForms[index].quantity = updatedForms[index].available_quantity;
    }

    calculateTotalPrice(index);
    setOrderForms(updatedForms);
  };

  const calculateTotalPrice = (index) => {
    const updatedForms = [...orderForms];
    const form = updatedForms[index];
    const totalPrice = parseFloat(form.price.replace(",", "")) * form.quantity;
    updatedForms[index].total_price = totalPrice.toFixed(2);
    setOrderForms(updatedForms);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedForms = [...orderForms];

    if (name === "discount") {
      // Ensure discount is not negative and defaults to 0 if empty
      const numericValue = value === "" ? "0" : Math.max(0, parseFloat(value) || 0).toString();
      updatedForms[index][name] = numericValue;
    } else {
      updatedForms[index][name] = value;
    }

    if (name === "discount" || name === "quantity") {
      const initialPrice = parseFloat(updatedForms[index].price) || 0;
      const discountPercentage = parseFloat(updatedForms[index].discount) / 100;
      const discountAmount = initialPrice * discountPercentage;
      const finalPrice = initialPrice - discountAmount;
      updatedForms[index].total_price = (finalPrice * updatedForms[index].quantity).toFixed(2);
    }

    setOrderForms(updatedForms);
    if (validationErrors[name]) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const calculateTotalPriceWithDiscount = (initialPrice, discount) => {
    if (!discount) return initialPrice;
    const discountPercentage = parseFloat(discount) / 100;
    const discountAmount = initialPrice * discountPercentage;
    const finalPrice = initialPrice - discountAmount;
    return finalPrice > 0 ? finalPrice : 0;
  };

  const incrementQuantity = (index) => {
    const updatedForms = [...orderForms];
    updatedForms[index].quantity += 1;
    calculateTotalPrice(index);
    setOrderForms(updatedForms);
  };

  const decrementQuantity = (index) => {
    const updatedForms = [...orderForms];
    if (updatedForms[index].quantity > 1) {
      updatedForms[index].quantity -= 1;
      calculateTotalPrice(index);
      setOrderForms(updatedForms);
    }
  };

  const handleAddMore = () => {
    setOrderForms((prevForms) => [...prevForms, createInitialForm()]);
  };

  const handleRemoveForm = (index) => {
    setOrderForms((prevForms) => prevForms.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const isValid = orderForms.every((form) => form.product_id && form.quantity && form.price && form.warehouse_id);
    if (!isValid) {
      toast.error("Make sure the product you picked has warehouse attached to it. If not please contact your warehouse manager.");
      setIsLoading(false);
      return;
    }

    const requestData = {
      customer_id: orderForms[0].customer_id,
      company_detail_id: orderForms[0].company_detail_id,
      warehouse_id: orderForms[0]?.warehouse_id,
      orders: orderForms.map((formData) => ({
        product_id: formData.product_id,
        category_id: formData.category_id,
        sub_category_id: formData.sub_category_id,
        price: formData.price,
        quantity: formData.quantity,
        discount: formData.discount,
        payment_type: formData.payment_type,
        total_price: formData.total_price,
        warehouse_id: formData.warehouse_id,
      })),
    };

    setApiError(null);

    try {
      const response = await axiosInstance.post("/user/order/create", requestData);
      const successMsg = response.data.message || "Order requested successfully";
      toast.success(successMsg);
      if (setParentSuccess) {
        setParentSuccess(successMsg);
      }
      setOrderForms([createInitialForm()]);
      closeModal();
      refreshPage();
    } catch (error) {
      console.error("Order Creation Error:", error);
      const errorMessage = error.response?.data?.message || error.message || "An error occurred";
      toast.error(errorMessage);
      setApiError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const resetAll = () => {
    setOrderForms([createInitialForm()]);
    // setCategories([]);
    // setSubCategories([]);
    setCompany([]);
    // setProducts([]);
    setWarehouses([]);
    setValidationErrors({});
    setApiError(null);
  };

  const handleClose = () => {
    resetAll();
    closeModal();
  };

  // Transform data for react-select
  const customerOptions = customers.map((customer) => ({
    label: `${customer.first_name} ${customer.last_name}`,
    value: customer.customer_id,
  }));

  const categoryOptions = categories.map((category) => ({
    label: category.name,
    value: category.id,
  }));

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="modal-lg">
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Request Order Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {apiError && (
            <div className="alert alert-danger alert-dismissible fade show" role="alert">
              <strong>Error!</strong> {apiError}
              <button type="button" className="btn-close" onClick={() => setApiError(null)} aria-label="Close"></button>
            </div>
          )}
          {orderForms.map((formData, index) => (
            <Row key={index}>
              {/* Customer Selection */}
              {index === 0 && (
                // <Col md={6} lg={6} xs={12} sm={12} className="mb-3">
                //   <Form.Group>
                //     <Form.Label><b>Customer</b></Form.Label>
                //     <AsyncSelect
                //       cacheOptions
                //       defaultOptions
                //       loadOptions={loadCustomerOptions}
                //       onChange={(option) => handleCustomerChange(index, option)}
                //       value={customerOptions.find((opt) => opt.value === formData.customer_id)}
                //       isSearchable
                //       placeholder="-- Select Customer --"
                //     />
                //     {validationErrors.customer_id && (
                //       <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                //         {validationErrors.customer_id[0]}
                //       </Form.Control.Feedback>
                //     )}
                //   </Form.Group>
                // </Col>
                <Col md={6} lg={6} xs={12} sm={12} className="mb-3">
                  <Form.Group>
                    <Form.Label><b>Customer</b></Form.Label>
                    <AsyncSelect
                      cacheOptions
                      defaultOptions
                      loadOptions={loadCustomerOptions}
                      onChange={(option) => handleCustomerChange(index, option)}
                      value={
                        formData.customer_id
                          ? { value: formData.customer_id, label: formData.customer_label }
                          : null
                      }
                      isSearchable
                      placeholder="-- Select Customer --"
                      isLoading={isCustomerLoading}
                    />
                    {validationErrors.customer_id && (
                      <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                        {validationErrors.customer_id[0]}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
              )}
              {/* Company Selection */}
              {index === 0 && (
                <Col md={6} lg={6} xs={12} sm={12} className="mb-3">
                  <Form.Group>
                    <Form.Label><b>Company</b></Form.Label>
                    <Select
                      options={company[index]?.map((com) => ({
                        label: com.company_name,
                        value: com.id,
                      }))}
                      onChange={(option) => handleCompanyChange(index, option)}
                      value={company[index]?.map((com) => ({
                        label: com.company_name,
                        value: com.id,
                      })).find((opt) => opt.value === formData.company_detail_id) || null}
                      isSearchable
                      placeholder="-- Select Company --"
                    />
                    {validationErrors.company_detail_id && (
                      <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                        {validationErrors.company_detail_id[0]}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
              )}

              <div className="mb-2" style={{ border: '1px dotted rgba(0, 0, 0, 0.5)' }}>
                <button className="btn btn-info d-flex justify-content-center mx-auto mt-1 mb-4" disabled>Item {index + 1}</button>
                <Row>
                  {/* Category Selection */}
                  <Col md={4} lg={4} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Category</b></Form.Label>
                      <Select
                        options={categoryOptions}
                        onChange={(option) => handleCategoryChange(index, option)}
                        value={categoryOptions.find((opt) => opt.value === formData.category_id) || null}
                        isSearchable
                        placeholder="-- Select Category --"
                      />
                      {validationErrors.category_id && (
                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                          {validationErrors.category_id[0]}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Subcategory Selection */}
                  <Col md={4} lg={4} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Sub Category</b></Form.Label>
                      <Select
                        options={(subcategories[index] || []).map((sub) => ({
                          label: sub.name,
                          value: sub.id,
                        }))}
                        onChange={(option) => handleSubCategoryChange(index, option)}
                        value={(subcategories[index] || []).map((sub) => ({
                          label: sub.name,
                          value: sub.id,
                        })).find((opt) => opt.value === formData.sub_category_id) || null}
                        isSearchable
                        placeholder="-- Select Sub Category --"
                      />
                      {validationErrors.sub_category_id && (
                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                          {validationErrors.sub_category_id[0]}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Product Selection */}
                  <Col md={4} lg={4} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Product</b></Form.Label>
                      <Select
                        options={(products[index] || []).map((prod) => ({
                          label: prod.product_name,
                          value: prod.id,
                        }))}
                        onChange={(option) => handleProductChange(index, option)}
                        value={(products[index] || []).map((prod) => ({
                          label: prod.product_name,
                          value: prod.id,
                        })).find((opt) => opt.value === formData.product_id) || null}
                        isSearchable
                        placeholder="-- Select Product --"
                      />
                      {validationErrors.product_id && (
                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                          {validationErrors.product_id[0]}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Warehouse Display */}
                  <Col md={6} lg={6} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Warehouse</b></Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.warehouseName}
                        readOnly
                        style={{ backgroundColor: "#f0f0f0", color: "#6c757d" }}
                      />
                    </Form.Group>
                  </Col>

                  {/* Available Quantity Display */}
                  <Col md={6} lg={6} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Available Quantity</b></Form.Label>
                      <Form.Control
                        type="text"
                        value={
                          formData.product_id && (formData.available_quantity === 0 || formData.available_quantity === null)
                            ? "Out of Stock"
                            : formData.available_quantity
                        }
                        readOnly
                        style={{
                          backgroundColor: "#f0f0f0",
                          color: formData.product_id && (formData.available_quantity === 0 || formData.available_quantity === null) ? "red" : "#6c757d",
                          fontWeight: formData.product_id && (formData.available_quantity === 0 || formData.available_quantity === null) ? "bold" : "normal"
                        }}
                      />
                    </Form.Group>
                  </Col>

                  {/* Quantity Input */}
                  <Col md={4} lg={4} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Quantity</b></Form.Label>
                      <div className="d-flex align-items-center">
                        <Button variant="secondary" onClick={() => decrementQuantity(index)}>-</Button>
                        <Form.Control
                          type="number"
                          name="quantity"
                          value={formData.quantity}
                          min="1"
                          onChange={(e) => {
                            handleChange(index, e);
                            calculateTotalPrice(index);
                          }}
                          style={{ margin: '0 10px', width: '70px' }}
                        />
                        <Button variant="secondary" onClick={() => incrementQuantity(index)}>+</Button>
                      </div>
                    </Form.Group>
                  </Col>

                  {/* Price Input */}
                  <Col md={4} lg={4} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Price</b></Form.Label>
                      <Form.Control
                        type="number"
                        name="price"
                        value={formData.price}
                        readOnly
                        style={{ backgroundColor: "#f0f0f0", color: "#6c757d" }}
                      />
                    </Form.Group>
                  </Col>

                  {/* Total Price Input */}
                  <Col md={4} lg={4} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Total Price</b></Form.Label>
                      <Form.Control
                        type="number"
                        name="total_price"
                        value={formData.total_price}
                        readOnly
                        style={{ backgroundColor: "#f0f0f0", color: "#6c757d" }}
                      />
                    </Form.Group>
                  </Col>

                  {/* Payment Type Input */}
                  <Col md={4} lg={4} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Payment Type</b></Form.Label>
                      <Form.Control
                        as="select"
                        name="payment_type"
                        value={formData.payment_type}
                        onChange={handleChange.bind(null, index)}
                      >
                        <option value="">-- Select Payment Type --</option>
                        <option value="cash">Cash/Prepaid</option>
                        <option value="credit">Credit</option>
                        <option value="transfer">Pay on Delivery</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  {/* Discount Input */}
                  <Col md={4} lg={4} xs={12} sm={12} className="mb-3">
                    <Form.Group>
                      <Form.Label><b>Discount</b></Form.Label>
                      <Form.Control
                        type="number"
                        name="discount"
                        value={formData.discount}
                        onChange={handleChange.bind(null, index)}
                        min="0"
                      />
                    </Form.Group>
                  </Col>

                  {/* Status Selection */}
                  {userTypeId === 3 && (
                    <Col md={4} lg={4} xs={12} sm={12} className="mb-3">
                      <Form.Group>
                        <Form.Label><b>Approval</b></Form.Label>
                        <Form.Control
                          as="select"
                          name="status"
                          value={formData.status}
                          onChange={handleChange.bind(null, index)}
                        >
                          <option value="">-- Select Status --</option>
                          <option value="approved">Approved</option>
                          <option value="pending">Pending</option>
                          <option value="rejected">Rejected</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  )}

                  {/* Remove Button */}
                  <div className="d-flex justify-content-end text-end">
                    <Col xs={12} className="mb-3">
                      {index > 0 && (
                        <Button variant="danger" onClick={() => handleRemoveForm(index)}>
                          <i className="ri-delete-bin-line"></i>
                        </Button>
                      )}
                    </Col>
                  </div>
                </Row>
              </div>
            </Row>
          ))}
          <div className="d-flex justify-content-center">
            <Button variant="primary" onClick={handleAddMore} style={{ fontWeight: "900", fontSize: "15px" }}>
              <i className="ri-add-line"></i> Add More Items
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button type="submit" variant="primary" disabled={isLoading}>
            {isLoading ? "saving..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}